import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

function parseJwtExpiry(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return payload.exp ? payload.exp * 1000 : null
  } catch {
    return null
  }
}

function loadUser() {
  const token = localStorage.getItem('token')
  if (!token) return null

  const exp = parseJwtExpiry(token)
  if (exp && exp < Date.now()) {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    return null
  }

  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function useAuth() {
  const navigate = useNavigate()
  const [user] = useState(loadUser)

  function logout() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    navigate('/login')
  }

  return { user, logout }
}
